/**
 * Legacy ImportJobExecutionsApiService module — preserved as an AngularJS
 * shell so existing dependencies (`acme.common.service.importJobExecutionsApi`)
 * and the JOB_EXECUTION_* constants injected by AJS controllers keep
 * resolving.
 *
 * The actual `ImportJobExecutionsApiService` is now an Angular 18 class
 * registered as a downgraded factory under the same name in
 *   apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts
 *
 * Implementation:
 *   apps/b2b-frontend/app/core/api/import-job-executions/import-job-executions-api.service.ts
 *
 * Do NOT register `.provider('ImportJobExecutionsApiService', ...)` here —
 * it would shadow the downgraded service.
 */
angular
  .module('acme.common.service.importJobExecutionsApi', [])
  .constant('JOB_EXECUTION_STATUS_TITLE', {
    uploaded: 'Uploaded',
    uploading: 'Uploading',
    created: 'Created',
    staging: 'Staging',
    staged: 'Staged',
    stagingError: 'Staging Error',
    validating: 'Validating',
    validated: 'Validation Completed',
    validationFailed: 'Validation Failed',
    validatedCompleteWithError: 'Validation Completed with Errors',
    externalValidatedCompleteWithError: 'ACME Validation Completed with Errors',
    externalValidating: 'Validating with ACME',
    externalValidated: 'ACME Validation Completed',
    externalValidationFailed: 'ACME Validation Failed',
    importing: 'Importing',
    imported: 'Imported',
    importFailed: 'Import Failed',
    exporting: 'Exporting',
    exportFailed: 'Export Failed',
    error: 'Error',
    unknown: 'Unknown',
    processed: 'Processed',
    processing: 'Processing',
    stopped: 'Stopped',
  })
  .constant('JOB_EXECUTION_ACTIVE_STATUSES', ['staging', 'validating', 'externalValidating', 'importing', 'processing'])
  .constant('JOB_EXECUTION_ERROR_CODES', {
    UNKNOWN: {
      title: 'Unknown',
      description: 'Unknown error, further investigation is required',
    },
    MISSING: {
      title: 'Missing',
      description: 'Value is empty or column is missing',
    },
    MISSING_ORGANIZATION: {
      title: 'Missing Organization',
      description: 'Reference to an Organization which does not exist',
    },
    MISSING_ADDRESS: {
      title: 'Missing Address',
      description: 'Reference to an Address which does not exist',
    },
    MISSING_NAME: {
      title: 'Missing Name',
      description: 'Organization does not have a name',
    },
    COLUMN_TO_LONG: {
      title: 'Column too Long',
      description: 'Column has too many characters in it',
    },
    COLUMN_TOO_LONG: {
      title: 'Column too Long',
      description: 'Column has too many characters in it',
    },
    MISSING_CUSTOMER: {
      title: 'Missing Customer',
      description: 'Reference to a customer which does not exist',
    },
    MISSING_CONTACT: {
      title: 'Missing Contact',
      description: 'Reference to a contact which does not exist',
    },
    BAD_ACCOUNT_CATEGORY: {
      title: 'Unspecified Account Category',
      description: 'The Organisation Account Category must be <blank> or; reseller, groupbuyer or corpmembership',
    },
    MISSING_EXTERNAL_ID: {
      title: 'Missing External ID',
      description: 'Customer record External ID is missing',
    },
    BAD_ADDRESS_TYPE: {
      title: 'Incorrect Address Type',
      description: 'The Address Type must be Primary or Secondary',
    },
    INVALID_DATE: {
      title: 'Invalid Date Format',
      description: 'The Date is not in the correct format which is yyyy-MM-dd HH:mm:ss',
    },
    DUPLICATE_ID: {
      title: 'Duplicate ID',
      description: 'An ID in the ID Column is duplicated',
    },
    INVALID_RELATION: {
      title: 'Invalid Relationship',
      description: 'Reference to a Membership Card which does not exist',
    },
  })
  .constant('JOB_EXECUTION_ERROR_STATUSES', {
    CUSTOMER_FIXABLE: 'Customer Fixable',
    ACME_FIXABLE: 'ACME Fixable',
    UNKNOWN: 'Unknown',
  })
  .constant('JOB_EXECUTION_ERROR_TYPES', {
    INTERNAL: 'Internal',
    EXTERNAL: 'External',
    IMPORT: 'Import',
    STAGE: 'Stage',
  })
  .constant('JOB_EXECUTION_ERROR_MESSAGES_TYPES', {
    ERROR: {
      class: 'error fa fa-exclamation-circle',
      message: 'Blocker',
      title: 'Records with blocker errors will not be imported.',
    },
    WARNING: {
      class: 'warning fa fa-exclamation-triangle',
      message: 'Warning',
      title: 'Records with warning errors will be imported.',
    },
  });
